import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ClinicTicketQuery, ClinicTicketQueryVariables } from '@/shared/api';
import CLINIC_TICKET_QUERY from '../queries/clinicTicket';

/**
 * Loads a single clinic support ticket by id. Runs CLINIC_TICKET_QUERY and throws a fixed failure message when the clinicTicket field comes back empty.
 *
 * @param id - Identifier of the clinic ticket.
 * @returns The clinic ticket record.
 */
const fetchClinicTicket = async (id: string) => {
  const client = createClient();
  const result = await client.query<ClinicTicketQuery, ClinicTicketQueryVariables>({
    query: CLINIC_TICKET_QUERY,
    variables: {
      id,
    },
  });
  const { clinicTicket } = result.data || {};
  if (_.isEmpty(clinicTicket)) {
    throw new Error('Failed to fetch clinic ticket!');
  }

  return clinicTicket;
};

export default fetchClinicTicket;
